export default {
  setSnackbarNotification(state, text) {
    state.notificationSnackbarText = text
  },
  hideSnackbarNotification(state) {
    state.notificationSnackbarText = ''
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setBreadcrumbCurrentView(state, payload) {
    state.breadcrumbCurrentView = payload
  },
  setBreadcrumbCurrentSubView(state, payload) {
    state.breadcrumbCurrentSubView = payload
  },
  setAudioPlayerIsPlaying(state, payload) {
    state.audioPlayerIsPlaying = payload
  },
  setAudioPlayerIsLoading(state, payload) {
    state.audioPlayerIsLoading = payload
  },
  setAudioPlayerFileKey(state, payload) {
    state.audioPlayerFileKey = payload
  },
}
